import { HeaderTwoColumnLayoutSkeleton } from 'layouts';

const CommunityLayoutSkeleton = () => (
  <HeaderTwoColumnLayoutSkeleton
    header={{ paragraph: { rows: 10 } }}
    left={[
      { paragraph: { rows: 4 } },
      { paragraph: { rows: 8 } },
      { paragraph: { rows: 8 } },
      { paragraph: { rows: 8 } },
      { paragraph: { rows: 8 } },
    ]}
    right={[{ paragraph: { rows: 6 } }, { paragraph: { rows: 4 } }]}
  />
);

export default CommunityLayoutSkeleton;
